export default __webpack_public_path__ + "static/media/edit.67a455c8.svg";